import Shape6 from "../../../assets/web/images/shape-6.svg";
import StoryImage from "../../../assets/web/images/story-image.png";
import Container from "../Container";
import PrimaryButton from "../PrimaryButton";

const Stories = () => {
  return (
    <section className="py-20 bg-[#FFF9F6]">
      <Container>
        <div className="grid grid-cols-1 sm:grid-cols-12 gap-6 items-center">
          <div className="col-span-7">
            <div>
              <img src={StoryImage} alt="Story Image" className="w-full" />
            </div>
          </div>
          <div className="col-span-5 relative">
            <div>
              <div className="text-black text-4xl font-semibold">
                <div>Stories You Would</div>
                <div>Want To Know</div>
              </div>

              <div className="text-textBody my-4">
                We have many stories about people and our loving clients. We
                gather their experience so that you can know more about us!
              </div>
              <PrimaryButton>Read our stories</PrimaryButton>
            </div>
            <img
              src={Shape6}
              alt=""
              className="absolute -bottom-[120px] -left-[140px]"
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Stories;
